<template>
    <v-dialog v-model="dialogCreatemail" persistent max-width="700px" style="overflow-y: hidden;">
      <v-card style="border-radius:20px;">
        <v-card tile>
          <v-toolbar flat style="background: #1a222c !important;">
            <v-toolbar-title class="white--text CSChatThai">
              <v-icon color="white">mdi-email-open-multiple-outline</v-icon>&nbsp;&nbsp;{{$t('Dialog.sendEmail.header')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark icon text @click="closeDialog">
              <v-icon style="color: white !important; font-size: 20px !important;">fa-solid fa-xmark</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card>
        <v-card-text style="padding-left: 30px;height: 535px; overflow-y: scroll;">
          <div style="overflow-y: hidden; margin: 10px;">
            <v-layout row wrap class="ma-2">
          <!-- <v-flex xs10 xl10 lg10 md10 sm10>
            <input type="text" :placeholder="$t('Dialog.sendEmail.to')" class="CSChatThai" v-model="to">
          </v-flex> -->
          <v-flex xs12 xl12 lg12 md12 sm12 class="mt-1 pr-2 pl-1">
            <v-combobox
              v-model="model"
              :items="items"
              :search-input.sync="search"
              hide-selected
              :label="$t('Dialog.sendEmail.to')"
              multiple
              persistent-hint
              small-chips
              deletable-chips
              dense
              outlined
              hide-details
            >
            </v-combobox>
          </v-flex>
          <v-flex xs12 xl12 lg12 md12 sm12 class="mt-1 mb-1">
            <span style="color: #666666; font-size: 12px; padding-left: 10px;">{{$t('Dialog.sendEmail.note2')}}</span>
          </v-flex>
    <!--       <v-flex xs2 xl2 lg2 md2 sm2 style="text-align: center;">
            <v-tooltip bottom>
            <v-btn style="background: #2562af; color: white;" fab dark small slot="activator">
              <v-icon style="color: white !important; font-size: 20px !important;" dark >mdi-account-multiple-plus-outline</v-icon>
            </v-btn>
            <span>เลือกเพื่อน</span>
          </v-tooltip>
          </v-flex> -->
          <v-flex xs12 xl12 lg12 md12 sm12 style="margin-top: 8px;" class="pr-2 pl-1">
            <input type="text" :placeholder="$t('Dialog.sendEmail.subject')" class="CSChatThai" v-model="subject">
          </v-flex>
            <v-flex xs12 xl12 lg12 md12 sm12 style="margin-top: 15px;">
                <!-- <VueTrix class="CSChatThai" inputId="editor1" v-model="editorContent" :placeholder="$t('Dialog.sendEmail.detail')"/> -->
            <!-- Create the editor container -->
            <!-- Create the toolbar container -->
            <quill-editor v-model="editorContent"
                :options="editorOption"
                @change="onEditorChange($event)">
  </quill-editor>

            </v-flex>
          <v-flex xs12 xl12 lg12 md12 sm12 style="margin-top: 8px;" v-if="message.message">
            <div class="attachment_file">
              <v-icon style="color: #666666;">mdi-paperclip</v-icon>
              <span style="color: #666666;">{{message.file_name}}</span>
            </div>
            <span style="color: red;" @click="clearMessage()"> {{$t('Dialog.sendEmail.removeFile')}} </span>
          </v-flex>
          <v-flex xs12 xl12 lg12 md12 sm12 style="margin-top: 15px; text-align: center;">
           <v-btn :loading="loading" style="background: #2562af; color: white; text-transform: none;" @click="sendmail()" :disabled="to === '' || subject === ''">
              <v-icon style="color: white !important; font-size: 20px !important;">mdi-send-outline</v-icon>
              {{$t('Dialog.sendEmail.send')}}
            </v-btn>
          </v-flex>
            </v-layout>
          </div>
    
        </v-card-text>
      </v-card>
    </v-dialog>
    </template>
    <script>
    // import { Decode } from '@/services'
    import VueTrix from "vue-trix"
    import 'quill/dist/quill.snow.css'
    import { quillEditor } from 'vue-quill-editor'
    export default {
      props: { 
        dialogCreatemail: false, 
        message: {},
        datauser: {},
    },
    components: {
        VueTrix,
        quillEditor
    },
//     mounted() {
//     this.editor = new Quill(this.$refs.editor, {
//       theme: 'snow',
//     });
//   },
    data () {
        return {
            editorOption: {
                placeholder: this.$t('Dialog.sendEmail.detail'),
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'], // ตัวเลือกการจัดข้อความ
                        [{ header: [1, 2, 3, false] }], // Header ขนาด 1, 2, 3
                        [{ list: 'ordered' }, { list: 'bullet' }], // ลิสต์แบบตัวเลขและ bullet
                        [{ align: [] }], // จัดเรียงข้อความ
                        // [{ color: [] }, { background: [] }], // เลือกสีตัวอักษรและพื้นหลัง
                        // ['link', 'image'], // แทรกลิงก์และรูปภาพ
                        ['clean'], // ล้างรูปแบบ
                    ],
                },
            },
            toolbarOptions: [
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                ['blockquote', 'code-block'],
            ],
            items: [],
            model: [],
            search: null,
            token: '',
            to: '',
            sender: '',
            subject: '',
            editorContent: '',
            listfriend: [],
            loading: false,
        }
    },
      created () {
        // var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
        this.editorContent = ""
        this.token = this.datauser.tokenuser
        this.sender = this.datauser.email
        // this.getlistfriend()
      },
      mounted () {
      },
      methods: {
        onEditorChange({ quill, html, text }) {
            // console.log('editor change!', quill, html, text)
            this.editorContent = html
        },
        closeDialog () {
          this.editorContent = ''
          this.subject = ''
          this.to = ''
          this.model = []
          this.$emit('closeComponents', {name: 'send-mail', value: false })
        },
        clearMessage () {
          this.message = {}
        },
        sendmail () {
          this.loading = true
          if (this.to === '') {
            this.loading = false
            this.$swal(
              '',
              this.$t('Alert.Fail.SendMail.inputMail'),
              'warning'
            )
          } else if (this.subject === '') {
            this.loading = false
            this.$swal(
              '',
              this.$t('Alert.Fail.SendMail.inputSubject'),
              'warning'
            )
          } else {
            this.axios.post(process.env.VUE_APP_API_EVENT + '/send_email', {sender: this.sender, to: this.to, subject: this.subject, detail: this.editorContent, file_name:(this.message.file_name)? this.message.file_name:'', file:(this.message.message)? this.message.message:''}).then((response) => {
              if (response.data.status === 'success') {
                this.loading = false
                this.$swal(
                  '',
                  this.$t('Alert.Success.sendEmail'),
                  'success'
                )
                this.closeDialog()
              }
            }).catch(error => {
              console.log(error)
              this.loading = false
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            })
          }
        },
        getlistfriend () {
          this.axios.post(process.env.APImanage + '/web/getlistfriend', {tokenuser: this.token}).then((response) => {
            if (response.data.status === 'success') {
              this.listfriend = response.data['listfriend']
            }
          }, () => {
          })
        },
        blockevent (data) {
          if (data.event === 'block_friend') {
            indexmsg = _.findIndex(this.listfriend, function (o) { return o.tokenuser === data.tokenuser })
            if (indexmsg != -1) {
              _.pullAt(this.listfriend, indexmsg)
            }
          } else if (data.event === 'unblock_friend') {
            this.listfriend.push(data)
            this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
          }
        }
      },
      watch: {
        model (val) {
          // if (val.length > 5) {
          //   this.$nextTick(() => this.model.pop())
          // }
          this.to = val.toString()
        },
        block_friend (data) {
          this.blockevent(data)
        },
        socketremove_friend (data) {
          var index = _.findIndex(this.listfriend, function (o) { return o.tokenroom === data.tokenroom })
          if (index >= 0) {
            this.listfriend.splice(index, 1)
          }
        },
        dialogCreatemail () {
            if (this.dialogCreatemail) {
                this.editorContent = ""
                // console.log("dialog mail", this.editorContent);
            }
        },
      }
    }
    </script>
    <style type="text/css" scoped>
    >>>.ql-editor {
    /* box-sizing: border-box; */
    counter-reset: list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    line-height: 1.42;
    height: 180px !important;
    outline: none;
    overflow-y: auto;
    padding: 12px 15px;
    -o-tab-size: 4;
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
}
    >>>.v-select.v-select--is-menu-active .v-input__icon--append .v-icon {
      display: none !important;
    }
    >>>.v-input__icon {
      display: none !important;
    }
    .btncreate {
      font-size: 13px !important;
      border-radius: 5px;
      margin-left: 0vw !important;
      margin-right: 15px!important;
      background: #2562af !important;
      color: white !important;
    }
    .btncancle {
      font-size: 13px !important;
      border-radius: 5px;
      margin-left: 0vw !important;
      margin-right: 10px !important;
      background: #e0e0e0 !important;
      color: black !important;
    }
    .text2 {
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    
    .close-classic:after {
      content: '×';
      font-size: 20px;
      /* ANSI X letter */
    }
    
    .containers {
      width: 454px;
      margin: 0 auto;
    }
    
    .containers:after {
      content: '';
      display: block;
      clear: both;
    }
    .listfile {
      overflow-x: scroll !important;
      overflow-y: hidden !important;
      height: 135px !important;
      display: -webkit-inline-box !important;
      background: #f3f2f2 !important;
      padding-top: 17px !important;
      border-radius: 10px !important;
      margin-bottom: 15px !important;
      margin-top: 20px;
    }
    
    .borderfile {
      border: 1px solid #00000036;
      border-radius: 5px;
      width: 140px !important;
      height: 100px !important;
      position: relative;
      background: white;
    }
    
    .Kanit {
      font-family: 'Kanit', sans-serif !important;
    }
    
    .alligator-turtle {
    
      object-fit: cover;
      object-position: 50% 0;
    }
    
    .application .theme--light.input-group input,
    .application .theme--light.input-group textarea,
    .theme--light .input-group input,
    .theme--light .input-group textarea {
      /* color: rgba(0,0,0,.87); */
      color: #53ceff !important;
    }
    
    .CSChatThai {
      font-family: 'CS ChatThaiUI' !important;
      word-wrap: break-word;
    }
    
    .user-photonote {
      height: 40px !important;
      width: 40px !important;
      background: #ccc;
      border-radius: 50%;
      overflow: hidden;
    
    }
    
    .textchat {
      white-space: nowrap;
      max-width: 9em;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: 'CS ChatThaiUI' !important;
      text-transform: none;
      display: inline-flex;
    }
    
    input[type=text] {
      width: 100%;
      box-sizing: border-box;
      border: 1px solid #b7b7b7;
      border-radius: 30px;
      font-size: 16px;
      background-color: white;
      /* background-image: url('/static/img/default_profile/group-white.png'); */
      background-position: 10px 10px;
      background-repeat: no-repeat;
      padding: 12px 20px 12px 20px;
      -webkit-transition: width 0.4s ease-in-out;
      transition: width 0.4s ease-in-out;
    }
    input[type=text]:focus {
        outline: none !important;
    }
    >>>.v-input .v-label {
        height: 20px;
        line-height: 24px;
    }
    >>>.trix-content {
        height: 220px !important;
    }
    >>>trix-editor:empty:not(:focus)::before {
        content: attr(placeholder);
        color: #858585;
        font-size: 16px;
        cursor: text;
    }
    >>>.trix-button-group--file-tools {
      display: none;
    }
    .attachment_file {
      border-radius: 3px;
      border: #bbbbbb 1px solid;
      background: #eee;
      width: fit-content;
      padding-left: 5px;
      padding-right: 5px;
      display: inline-block;
    }
    >>>.v-input__slot {
      border-radius: 30px !important;
      border-width: thin !important;
      border-color: #b7b7b7 !important;
    }
    </style>
    